import AppLayout from "../AppLayout";
import QuickSearch from "../Home/Home";
import Login from "../../pages/Login";
import Logout from "../../pages/Logout";
import DRNUpload from "../DRNUpload/DRNUpload";
import MainHeader from "../PublicComponents/MainHeader";
import UnAuth from "../PublicComponents/UnAuth";
import { useUser } from "../../contexts/userContextApi";
import AdvancedSearch from "../AdvancedSearch/AdvancedSearch";

import {
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { useEffect } from "react";
export default function AppContent() {
  const user = useUser();
  
  return (
    <>
      <MainHeader />

      <Routes>
        <Route
          path="/"
          element={<Login />}
        />

        <Route path="/drn" element={<AppLayout />}>
        <Route index element={<Navigate to="quickSearch" replace />} />
          <Route path="quickSearch" element={<QuickSearch />} />
          <Route path="uploadDrn" element={<DRNUpload />} />
          {/* <Route path="advancedSearch" element={<AdvancedSearch />} /> */}
          <Route path="logout" element={<Logout />} />
        </Route>
       
        <Route path="/UnAuthorize" element={<UnAuth />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}